// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}
.fw-semibold {
  font-weight: 600 !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.681) !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}
small,
.small {
  font-size: 0.875em;
}
`, "",{"version":3,"sources":["webpack://./src/utils/Css/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,UAAU;EACV,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;AACA;;EAEE,kBAAkB;AACpB","sourcesContent":[".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.text-medium-emphasis {\n  --cui-text-opacity: 1;\n  color: rgba(44, 56, 74, 0.681) !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\nsmall,\n.small {\n  font-size: 0.875em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
